import { render, staticRenderFns } from "./PasoMapeoColumnas.vue?vue&type=template&id=38d1a19a&scoped=true&"
import script from "./PasoMapeoColumnas.vue?vue&type=script&lang=js&"
export * from "./PasoMapeoColumnas.vue?vue&type=script&lang=js&"
import style0 from "./PasoMapeoColumnas.vue?vue&type=style&index=0&id=38d1a19a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d1a19a",
  null
  
)

export default component.exports